import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import PatientPsychoResult from './PatientPsychoResult';

loadDOMComponent({
	selector: 'react-patient-psycho-result',
	callback: ({ container }) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<AppContextProvider>
				<PatientPsychoResult userId={userId} />
			</AppContextProvider>,
			container,
		);
	},
});
